mutation updateOptionalFields($input: UpdateOptionalFieldsInput!) {
  updateOptionalFields(input: $input) {
    company {
      isFirstNameOptional
      enabledFirstNameVerification {
        VALUATION
      }
      isLastNameOptional
      enabledLastNameVerification {
        VALUATION
      }
      isMotivationOptional
      enabledMotivationVerification {
        VALUATION
      }
    }
  }
}
